import { useState } from "react";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Checkbox, Col, Modal, Row, Tooltip, Typography } from "antd";
import {
  InfoCircleOutlined,
  LoadingOutlined,
  MailOutlined,
} from "@ant-design/icons";
import Button from "../Button";
import { getBrowser } from "../../utils";
import { handleDarfSend } from "./handlers";
import { getTooltipMessage } from "../../pages/Darfs/tooltip";
import { IClient, useClients } from "../../contexts/ClientsContext";
import { yearConfigPL4173 } from "../../constants/others/exterior";

interface IProps {
  showSendDarfModal: boolean;
  setShowSendDarfModal: any;
  whatsappRedirectURL: string | undefined;
  setWhatsappRedirectURL: any;
  clientsSelected: IClient[];
  setClientsSelected: any;
  setKeys?: any;
  sendToResp: boolean;
  setSendToResp: any;
}

export const SendDarfModal = ({
  setKeys,
  sendToResp,
  setSendToResp,
  clientsSelected,
  showSendDarfModal,
  setClientsSelected,
  whatsappRedirectURL,
  setShowSendDarfModal,
  setWhatsappRedirectURL,
}: IProps) => {
  const [emailFlow, setEmailFlow] = useState(false);
  const [whatsappFlow, setWhatsappFlow] = useState(false);
  const { loadingGet, getClients, setLoadingGet } = useClients();

  
  const oldModel = !!clientsSelected.find(c => ((c?.year || 2023) < yearConfigPL4173 && c?.type === 'Exterior') || c?.type !== 'Exterior')
  const darfLabel = oldModel ? 'DARF' : 'relatório'
  
  return (
    <Modal
      footer={null}
      open={showSendDarfModal}
      className="envio-darf-modal"
      title={
        (emailFlow || whatsappFlow || clientsSelected.length > 1) && !loadingGet
          ? "Confirmar envio"
          : `Enviar ${oldModel ? 'DARF' : 'Relatório'}`
      }
      onCancel={() => {
        setShowSendDarfModal(false);
        setEmailFlow(false);
        setWhatsappFlow(false);
        setWhatsappRedirectURL(undefined);
        setClientsSelected([]);
        setKeys([]);
      }}
    >
      {loadingGet && (
        <>
          <Row justify="start">
            <Col span={24} style={{ margin: "1rem 0 2rem 0" }}>
              <Typography.Text>
                {whatsappRedirectURL === "loading"
                  ? `Por favor, aguarde um instante enquanto geramos o ${darfLabel}. Logo após você poderá enviá-lo por Whatsapp.`
                  : `Por favor, aguarde um instante enquanto geramos e enviamos os ${darfLabel}s por e-mail.`}
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={1} style={{ margin: "1rem 0 2rem 0" }}>
              <LoadingOutlined />
            </Col>
          </Row>
        </>
      )}
      {(emailFlow || clientsSelected.length > 1) && !loadingGet && (
        <>
          <Row justify="end">
            <Col span={24} style={{ margin: "0 0 1.5rem 0" }}>
              <Typography.Text style={{ fontSize: "14px" }}>
                <a
                  href={oldModel ? "https://velotax-assets.s3.amazonaws.com/mail-darf-template.pdf" : "https://velotax-assets.s3.amazonaws.com/mail-relatorio-template.pdf"}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "var(--ant-primary-color)" }}
                >
                  Clique aqui {` `}
                </a>
                caso queira ver uma prévia de como seu cliente receberá o e-mail
                antes de confirmar o envio.
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="end">
            <Col span={24} style={{ margin: "0 0 1.5rem 0" }}>
              <Checkbox
                value={sendToResp}
                onChange={(e) => setSendToResp(e.target.checked)}
                style={{ fontSize: "14px", fontWeight: "100" }}
              >
                Enviar com o profissional responsável em cópia
              </Checkbox>
            </Col>
          </Row>
          <Row justify="end">
            <Col span={24}>
              <Button
                block
                size="large"
                type="primary"
                disabled={loadingGet}
                onClick={() =>
                  handleDarfSend({
                    sendToWhatsapp: false,
                    clientsSelected,
                    filters: {},
                    getClients,
                    sendToResp,
                    setLoadingGet,
                    setSendToResp,
                    setEmailFlow,
                    setWhatsappFlow,
                    setShowSendDarfModal,
                    setWhatsappRedirectURL,
                  })
                }
              >
                {loadingGet ? (
                  <LoadingOutlined />
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <MailOutlined style={{ marginRight: "8px" }} />
                    <strong>CONFIRMAR ENVIO POR E-MAIL</strong>
                  </div>
                )}
              </Button>
            </Col>
          </Row>
          {emailFlow && (
            <Row justify="start">
              <Col>
                <Button
                  type="link"
                  size="middle"
                  icon={<AiOutlineArrowLeft />}
                  style={{
                    height: "40px",
                    paddingLeft: "0",
                    margin: "8px 0 -24px",
                  }}
                  onClick={() => {
                    setEmailFlow(false);
                  }}
                >
                  VOLTAR
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
      {whatsappFlow && !loadingGet && (
        <>
          <Row justify="end">
            <Col span={24}>
              <Button
                block
                size="large"
                type="primary"
                disabled={loadingGet}
                onClick={() =>
                  handleDarfSend({
                    sendToWhatsapp: true,
                    clientsSelected,
                    filters: {},
                    getClients,
                    sendToResp,
                    setLoadingGet,
                    setSendToResp,
                    setEmailFlow,
                    setWhatsappFlow,
                    setShowSendDarfModal,
                    setWhatsappRedirectURL,
                  })
                }
              >
                {loadingGet ? (
                  <LoadingOutlined />
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <BsWhatsapp style={{ marginRight: "8px" }} />
                    <strong>CONFIRMAR ENVIO POR WHATSAPP</strong>
                  </div>
                )}
              </Button>
            </Col>
          </Row>
          <Row justify="start">
            <Col>
              <Button
                type="link"
                size="middle"
                icon={<AiOutlineArrowLeft />}
                style={{
                  height: "40px",
                  paddingLeft: "0",
                  margin: "8px 0 -24px",
                }}
                onClick={() => {
                  setWhatsappFlow(false);
                }}
              >
                VOLTAR
              </Button>
            </Col>
          </Row>
          <Typography.Text
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "100",
              lineHeight: "20px",
              paddingTop: "16px",
              color: "var(--gray-2)",
              margin: "40px 0 -16px",
              borderTop: "1px solid var(--ghost)",
            }}
          >
            <Tooltip title={getTooltipMessage(getBrowser())}>
              <InfoCircleOutlined
                style={{ marginRight: "0.5rem", cursor: "pointer" }}
              />
            </Tooltip>
            Caso sua mensagem não seja enviada, por favor, habilite os pop-ups e
            redirecionamentos em seu navegador clicando em{" "}
            <strong>"Configurações do site"</strong> e ativando a opção{" "}
            <strong>"Permitir"</strong>.
          </Typography.Text>
        </>
      )}
      {!emailFlow && !whatsappFlow && clientsSelected.length === 1 && (
        <>
          <Row justify="end" style={{ marginBottom: "8px" }}>
            <Col span={24}>
              <Typography.Paragraph>
                Defina abaixo a forma como deseja enviar o {darfLabel} para o cliente
                selecionado:
              </Typography.Paragraph>
            </Col>
            <Col span={24}>
              <Button
                block
                size="large"
                type="primary"
                disabled={loadingGet}
                onClick={() => {
                  setWhatsappFlow(false);
                  setEmailFlow(true);
                }}
              >
                {loadingGet ? (
                  <LoadingOutlined />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <MailOutlined style={{ marginRight: "8px" }} />
                    <strong>ENVIAR {darfLabel.toUpperCase()} POR E-MAIL</strong>
                  </div>
                )}
              </Button>
            </Col>
          </Row>
          {oldModel && <Row justify="end">
            <Col span={24}>
              <Button
                block
                size="large"
                type="primary"
                disabled={loadingGet}
                onClick={() => {
                  setEmailFlow(false);
                  setWhatsappFlow(true);
                }}
              >
                {loadingGet ? (
                  <LoadingOutlined />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <BsWhatsapp style={{ marginRight: "8px" }} />
                    <strong>ENVIAR {darfLabel.toUpperCase()} POR WHATSAPP</strong>
                  </div>
                )}
              </Button>
            </Col>
          </Row>}
        </>
      )}
    </Modal>
  );
};
